module.exports = __webpack_public_path__ + "img/8D8D8D_DDDDDD_CCCCCC_B7B7B7-256px.73d297db.png";